/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { View, Dimensions } from 'react-native';
import Toast from 'react-native-toast-message';
import { isWeb } from '@global/screens';
import Colors from '@global/colors';
import ModalHalf from '@components/modal/ModalHalf';
import Button from '@components/form/Button';
import Input from '@components/form/Input';
import SociollaText from '@components/sociolla/SociollaText';

import { MsB2b } from '@api/ms-b2b';
import { showPopup } from '@/store/modal';

const dimension = Dimensions.get('screen');

const RejectActivity = ({ id, show, onClose, onSubmit }) => {
  const dispatch = useDispatch();
  const [notes, setNotes] = useState('');

  useEffect(() => {
    let mounted = true;
    if (mounted && show) {
      setNotes('');
    }
    return () => {
      mounted = false;
    };
  }, [show]);

  const onSubmitReject = async () => {
    try {
      const updateData = await MsB2b.updateSalesActivityStatus(id, 'rejected', {
        notes: notes,
      });
      if (updateData && updateData.data && updateData.data.data) {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        onSubmit();
      } else {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'A system error occurred', type: 'error' });
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({ text1: 'A system error occurred', type: 'error' });
    }
  };

  return (
    <ModalHalf
      testID="sales-activity-reject-modal"
      title="Reject Activity Plan"
      visible={show}
      maxWidth={isWeb ? 350 : '100%'}
      spaceFromTop={isWeb ? '10%' : false}
      onClose={() => onClose()}>
      <View style={{ width: '100%' }}>
        <View style={{ width: '100%', padding: isWeb ? 15 : 20 }}>
          <SociollaText style={{ marginBottom: 15 }}>
            Please fill in the reason for rejection.
          </SociollaText>
          <View style={{ width: '100%' }}>
            <Input
              testID="sales-activity-reject-notes"
              label="Notes"
              value={notes}
              multiline={true}
              numberOfLines={4}
              isRequired={true}
              onChangeText={(value) => setNotes(value)}
            />
          </View>
        </View>
        <View
          style={{
            width: '100%',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            paddingVertical: 15,
            borderTopColor: isWeb ? 'transparent' : Colors.grey0,
            borderTopWidth: 1,
          }}>
          <Button
            testID="sales-activity-reject-submit-btn"
            rounded={true}
            buttonStyle={{ width: isWeb ? 150 : dimension.width - 40 }}
            disabledStyle={{ width: isWeb ? 150 : dimension.width - 40 }}
            disabled={!notes}
            title={
              <SociollaText
                type="bold"
                style={{
                  fontSize: 14,
                  letterSpacing: 0.5,
                  color: Colors.white,
                }}>
                Submit
              </SociollaText>
            }
            onPress={() => onSubmitReject()}
          />
        </View>
      </View>
    </ModalHalf>
  );
};

export default React.memo(RejectActivity, (prev, next) => prev == next);
